import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { asyncRequest, Entities, fetchById, search, TOMCAT_URL } from 'src/common';
import EmailToJourneyForm from 'src/components/admin/email-to-journey/components/email-to-journey-form';
import CircularProgress from 'material-ui/CircularProgress';
import { addErrorNotification } from 'src/actions/notifications';

class EmailToJourneyEditModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
            showFormResult: false,
            loading: false,
            offerUrl: null,
        };
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { loading, offerUrl } = this.state;

        return (
            <div className="col-md-12">
                {loading && (
                    <>
                        <div
                            className="col-md-12"
                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            {' '}
                            <CircularProgress /> <p>Ihre Anfrage wird verarbeitet</p>{' '}
                        </div>
                    </>
                )}
                {!loading && offerUrl == null && (
                    <EmailToJourneyForm
                        onSubmit={this.handleSubmit}
                        ref={ref => (this.childForm = ref)}
                        offerUrl={offerUrl}
                    />
                )}
                {this.state.showFormResult && (
                    <>
                        <div className="row col-md-12">
                            <p>
                                <span>Anfrage war erfolgreich: &nbsp;</span>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        const win = window.open(this.state.offerUrl, '_blank');
                                        if (win != null) win.focus();
                                    }}>
                                    Angebot erstellen
                                </button>
                            </p>
                        </div>
                    </>
                )}

                <button
                    className="btn pull-right btn-primary"
                    style={{ marginBottom: 10 }}
                    onClick={() => {
                        this.props.refetch();
                        this.props.handleClose();
                    }}>
                    Schließen
                </button>
            </div>
        );
    }

    handleSubmit(data) {
        this.setState({ loading: true });
        asyncRequest({
            method: 'POST',
            endpoint: `${TOMCAT_URL}api/${Entities.EMAIL_TO_OFFER.repository}/get-journey`,
            body: {
                email: data.emailInput,
            },
        })
            .then(response => {
                if (response.json.emailToJourney.insufficientResponse) this.setState({ loading: false });
                else this.setState({ offerUrl: response.json.url, showFormResult: true, loading: false });
            })
            .catch(error => {
                this.props.addErrorNotification({ code: error.status, message: error.statusText });
                this.setState({ loading: false });
            });
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

export default connect(
    mapStateToProps,
    {
        fetchById,
        search,
        addErrorNotification,
    },
    null,
    { withRef: true },
)(EmailToJourneyEditModal);
